import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider } from 'react-router';
import { Toaster } from 'sonner';
import { ApiError, setSessionExpiredHandler } from '@/services/api';
import { sessionKey } from '@/features/auth/session';
import { router } from '@/app/router';
import '@/styles/global.css';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      refetchOnWindowFocus: false,
      // Client errors (4xx) are final; only network/timeout/5xx failures are retried.
      retry: (count, err) => count < 2 && (!(err instanceof ApiError) || err.isRetryable),
    },
    mutations: { retry: false },
  },
});

setSessionExpiredHandler(() => {
  queryClient.setQueryData(sessionKey, null);
});

const root = document.getElementById('root');
if (!root) throw new Error('Missing #root');
createRoot(root).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <RouterProvider router={router} />
      <Toaster position="bottom-right" duration={4500} richColors closeButton />
    </QueryClientProvider>
  </StrictMode>,
);
